import React, { useContext } from 'react'
import { replaceInTranslation } from 'client/common/utils'
import { TranslateContext } from 'client/common/translator'
import { useSelector } from 'react-redux'
import { SHOW_TOP_SUBCATEGORIES } from 'common/constants'
import { isFlagInGA, pushFlagToDatalayer } from '../../../../common/gtmEvents'

const CategoryAdvise = ({ categoryName, categoryCode }) => {
  const t = useContext(TranslateContext)
  const adviceSlug = useSelector(state => state.data.adviceSlug)
  const lang = useSelector(state => state.data.lang)
  const flagsToGA = useSelector(store => store.data?.flags?.flagsToGA)

  const translationKey = `lister.advice.${categoryCode}`
  const showCategoryAdvice = (categoryCode && t(translationKey) !== translationKey) || adviceSlug
  if (!showCategoryAdvice) return null

  const adviceLink = adviceSlug ? adviceUrl(lang, adviceSlug) : t(translationKey)

  return (
    <div
      className='mxd-category-advice mt1'
      onClick={() => {
        if (isFlagInGA({ flagsToGA, ldFlag: SHOW_TOP_SUBCATEGORIES })) {
          pushFlagToDatalayer({
            ldFlag: 'show-top-subcategories',
            ldVariation: 'advice-link-clicked'
          })
        }
      }}
    >
      <a className='' href={adviceLink} target='_blank' rel='noreferrer'>
        {replaceInTranslation(t('lister.advice.text'), { categoryName })}
      </a>
    </div>
  )
}

const PREFIX_MAPPING = {
  nl: '/productadvies',
  nl_BE: '/nl/koopadvies',
  fr: '/fr/recommandation-produits'
}
const adviceUrl = (lang, slug) => `${PREFIX_MAPPING[lang]}/${slug}`

export default CategoryAdvise
